module.exports = __webpack_public_path__ + "static/media/jdrManoir_02_thumb_hover.4d55ee4f.png";